import React from 'react';
import styled from 'styled-components/macro';
import RoundImage from './RoundImage';
import Name from './Name';
import Title from './Title';
import { MOBILE_WIDTH } from '../../constants/dims';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${props => props.theme.about.description.backdrop};
  z-index: 2000;
  cursor: pointer;
`;

const Canvas = styled.div`
  width: 50%;
  min-width: 400px;
  height: auto;
  max-height: 75%;
  color: ${props => props.theme.about.description.text};
  background-color: ${props => props.theme.about.description.backgroundColor};
  overflow-y: auto;
  padding: 40px;
  box-sizing: border-box;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    max-height: 100%;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  padding-top: 0;
  box-sizing: border-box;
`;

const Description = ({ img, name, title, description, onClose }) => {
  if (typeof description === 'string') {
    description = [description];
  }

  return (
    <Container
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <Canvas>
        <Row>
          <RoundImage src={img} alt={name} />
          <Name>{name}</Name>
          {title && <Title>{title}</Title>}
        </Row>
        {description.map((desc, i) => (
          <p key={i}>{desc}</p>
        ))}
      </Canvas>
    </Container>
  );
};

export default Description;
